export default __webpack_public_path__ + "static/media/cog.9e8f794a.svg";